"use client"

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { IconLogout } from "@tabler/icons-react"

interface LogoutConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  accountName: string
  accountLogin: string
  onConfirm: () => void
  dialogTitle?: string
  dialogDescription?: string
  confirmLabel?: string
}

export function LogoutConfirmDialog({
  open,
  onOpenChange,
  accountName,
  accountLogin,
  onConfirm,
  dialogTitle,
  dialogDescription,
  confirmLabel = "Выйти",
}: LogoutConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>{dialogTitle ?? "Выйти из аккаунта?"}</DialogTitle>
          <DialogDescription>
            {dialogDescription ?? (
              <>
                Вы выйдете из аккаунта{" "}
                <span className="font-medium text-foreground">{accountName}</span>
                {accountLogin && accountLogin !== accountName && (
                  <> ({accountLogin})</>
                )}
                . Войти снова можно в любое время.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Отмена</Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={() => { onConfirm(); onOpenChange(false) }}
            className="gap-2"
          >
            <IconLogout className="size-4" />
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
